'use client';
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import React, { useRef, useCallback } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import PickerCircle from './PickerCircle';
import { hsvToRgb, rgbToHex } from './colorUtils';
var Container = styled(Box)(function (_ref) {
    var theme = _ref.theme;
    return _defineProperty(_defineProperty({
        width: '100%',
        height: '12px',
        flexShrink: 0,
        position: 'relative',
        marginTop: '16px',
        cursor: 'pointer'
    }, theme.breakpoints.down('md'), {
        width: '100%',
        maxWidth: '100%'
    }), theme.breakpoints.down('sm'), {
        width: '100%',
        height: '8px',
        marginTop: '12px'
    });
});
var Slider = styled(Box)(function (_ref3) {
    var theme = _ref3.theme;
    return _defineProperty(_defineProperty({
        width: '100%',
        height: '12px',
        flexShrink: 0,
        borderRadius: '24px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        background: 'linear-gradient(270deg, #ff0008 0%, #ff00eb 16.67%, #0e00ff 32.81%, #00edff 49.06%, #0f0 67.97%, #fffe00 83.12%, #ff0800 100%)',
        position: 'absolute',
        left: 0,
        top: 0
    }, theme.breakpoints.down('md'), {
        width: '100%',
        maxWidth: '100%'
    }), theme.breakpoints.down('sm'), {
        width: '100%',
        height: '8px'
    });
});
var StyledPickerCircle = styled(PickerCircle)(function (_ref5) {
    var position = _ref5.position, theme = _ref5.theme;
    return _defineProperty({
        left: "".concat(position - 16, "px"),
        top: '-10px',
        cursor: 'grab',
        '&:active': {
            cursor: 'grabbing'
        }
    }, theme.breakpoints.down('sm'), {
        left: "".concat(position - 12, "px"),
        top: '-8px'
    });
});
var HuePicker = function HuePicker(_ref7) {
    var currentColor = _ref7.currentColor, onChange = _ref7.onChange, huePosition = _ref7.huePosition, onHuePositionChange = _ref7.onHuePositionChange;
    var containerRef = useRef(null);
    var handleMouseDown = useCallback(function (event) {
        if (!containerRef.current)
            return;
        var rect = containerRef.current.getBoundingClientRect();
        var x = Math.max(0, Math.min(320, event.clientX - rect.left));
        var hue = Math.round(x / 320 * 360);
        var rgb = hsvToRgb(hue, currentColor.hsv.s, currentColor.hsv.v);
        var hex = rgbToHex(rgb.r, rgb.g, rgb.b);
        onHuePositionChange(x);
        onChange === null || onChange === void 0 || onChange({
            hex: hex,
            rgb: rgb,
            hsv: {
                h: hue,
                s: currentColor.hsv.s,
                v: currentColor.hsv.v
            }
        });
        var handleMouseMove = function handleMouseMove(moveEvent) {
            var newX = Math.max(0, Math.min(320, moveEvent.clientX - rect.left));
            var newHue = Math.round(newX / 320 * 360);
            var newRgb = hsvToRgb(newHue, currentColor.hsv.s, currentColor.hsv.v);
            var newHex = rgbToHex(newRgb.r, newRgb.g, newRgb.b);
            onHuePositionChange(newX);
            onChange === null || onChange === void 0 || onChange({
                hex: newHex,
                rgb: newRgb,
                hsv: {
                    h: newHue,
                    s: currentColor.hsv.s,
                    v: currentColor.hsv.v
                }
            });
        };
        var _handleMouseUp = function handleMouseUp() {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', _handleMouseUp);
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', _handleMouseUp);
    }, [currentColor.hsv.s, currentColor.hsv.v, onChange, onHuePositionChange]);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        onMouseDown: handleMouseDown
    }, /*#__PURE__*/ React.createElement(Slider, null), /*#__PURE__*/ React.createElement(StyledPickerCircle, {
        color: currentColor.hex,
        className: "picker-circle-hue",
        position: huePosition
    }));
};
export default HuePicker;
